/* tslint:disable */
export var ShopType;
(function (ShopType) {
    ShopType[ShopType["unknown"] = 0] = "unknown";
    ShopType[ShopType["Shop1"] = 1] = "Shop1";
    ShopType[ShopType["Shop2"] = 2] = "Shop2";
    ShopType[ShopType["Shop3"] = 3] = "Shop3";
    ShopType[ShopType["MobileShop"] = 4] = "MobileShop";
    ShopType[ShopType["Tbd"] = 5] = "Tbd";
    ShopType[ShopType["Facebook"] = 6] = "Facebook";
})(ShopType || (ShopType = {}));
/* tslint:enable */



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/types/ShopTypeEnum.ts
// module id = 801
// module chunks = 3